var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLessThanEqual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.531 222.062L382.531 366.062C385.625 367.375 388.844 368 392 368C401.312 368 410.156 362.562 414.062 353.469C419.281 341.281 413.625 327.156 401.469 321.937L116.938 200L401.469 78.062C413.625 72.844 419.281 58.719 414.063 46.531C408.813 34.344 394.781 28.75 382.531 33.937L46.531 177.937C37.719 181.719 32 190.406 32 200S37.719 218.281 46.531 222.062ZM424 432H24C10.75 432 0 442.75 0 456S10.75 480 24 480H424C437.25 480 448 469.25 448 456S437.25 432 424 432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessThanEqual);
export default __webpack_public_path__ + "static/media/less-than-equal.ea8b7a18e8494c9111775455e9fe900b.svg";
export { ForwardRef as ReactComponent };